import { RouteConfig } from 'vue-router'

export const IndexRoute: RouteConfig = {
  path: '/activity/summer-points-2026',
  name: 'activity_summer_points_2026',
  component: () => import('./2026-summer/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026暑假体育作业学生积分活动',
  },
}

export const AuctionWinnersRoute: RouteConfig = {
  path: '/activity/motivation-point/auction-winners',
  name: 'activity_motivation_point_auction_winners',
  component: () => import('./auction-winners/AuctionWinners.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '竞拍获奖名单',
  },
}

export default [IndexRoute, AuctionWinnersRoute]
